import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import CustomTableService from "services/CustomTable";

const permissionsKey = slug => ["custom-table-permissions", slug];

/**
 * Loads the per-role grants for a single custom table and exposes a mutator
 * for toggling individual flags. Used by the schema editor's permissions panel.
 */
export const useCustomTablePermissions = slug => {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: permissionsKey(slug),
    queryFn: () => CustomTableService.listPermissions(slug),
    enabled: !!slug,
  });

  const mutation = useMutation({
    mutationFn: ({ roleId, data }) =>
      CustomTableService.updatePermission(slug, roleId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: permissionsKey(slug) });
    },
  });

  return {
    permissions: query.data ?? [],
    isFetched: query.isFetched,
    isError: query.isError,
    updatePermission: mutation.mutateAsync,
    isUpdating: mutation.isPending,
  };
};
